export default {
	section_banner: {
		title: {
			one: 'One Tether',
		},
		main_title: {
			one: 'Independent',
		},
		sub_title: {
			one: 'Seat',
			two: 'System',
		},
		paragraph: {
			one: 'It is like installing a metal door over an existing one-adding an extra layer of protection, but possibly unnecessary or redundant if the original door was already secure.',
		},
		cta_buttons: {
			one: 'Cryptocurrency Request',
			two: 'Download App',
		},
	},

	question_sec: {
		label: 'ZIGA From Tether',
		title: {
			one: 'Independent',
			two: 'Seating',
			three: 'System',
		},
		paragraph: {
			one: 'It is time to come and go, moving in and out between moments. From step one to three, the rhythm continues. The thought of it sparks reflection—just as soon as the idea appears, it brings more thoughts with it.',
		},
		cta_buttons: {
			one: 'Get Started',
		},
	},

	online_mid: {
		label: 'Transaction With Us',
		title: {
			one: 'Sending',
			two: 'Money',
			three: 'Let’s Go Together',
		},
		paragraph: {
			one: 'Sending money is simple and seamless with JPWorldPay—lets go together on a journey of fast, secure, and reliable transfers. Whether you are supporting loved ones or paying for services, JPWorldPay makes the process easy and efficient for everyone involved.',
		},
		cta_buttons: {
			one: 'Get Started',
		},
	},

	received_request_sec: {
		label: 'Select A JPWorldPay User',
		title: {
			one: 'Enter The ',
			two: 'Requested',
			three: 'Amount',
		},
		paragraph: {
			one: 'You can simplify the daily reception of cryptocurrency by instantly creating a link to request assets through JPWorldPay. This streamlined process makes it easy to receive payments quickly and securely, allowing you to manage your transactions with ease. Stay in control of your finances and enjoy seamless transfers every time. With JPWorldPay, managing cryptocurrency has never been simpler.',
			two: 'JPWorldPay allows you to manage your assets with ease, offering a seamless experience whether you are buying, selling, or transferring. Its user-friendly interface ensures even complex transactions feel effortless.',
		},
		cta_buttons: {
			one: 'CREATING A JPWORLDPAY LINK',
		},
	},

	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
